<template>
  <v-form
    v-if="draft"
    v-model="isValid"
  >
    <v-card>
      <v-card-title primary-title>
        <div>
          <v-layout
            row
            align-center
          >
            <v-tooltip bottom>
              <v-btn
                slot="activator"
                small
                icon
                class="ma-0"
                @click="$router.go(-1)"
              >
                <v-icon color="grey darken-1">
                  arrow_back
                </v-icon>
              </v-btn>
              <span>Назад</span>
            </v-tooltip>
            <h3 class="headline mb-0">
              Черновик для фабрики {{ draft.Title }}
            </h3>
          </v-layout>
        </div>
      </v-card-title>
      <v-card-text
        v-for="(item,index) in draft.Data"
        :key="index"
      >
        <div class="mb-3">
          <h3 class="title">
            {{ item.AnotherLoadingPlace ? "Доп. место погрузки" : "Производитель" }}
          </h3>
        </div>
        <v-layout v-if="!item.AnotherLoadingPlace">
          <v-flex>
            <v-text-field
              v-model="item.Title"
              class="mx-2 my-0"
              label="Название фабрики*"
              hide-details
              :rules="commonRules"
              :readonly="item.Title !== ''"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="item.Phone"
              class="mx-2 my-0"
              label="Телефон*"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="item.Email"
              class="mx-2 my-0"
              label="E-mail*"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="item.Notes"
              class="mx-2 my-0"
              label="Специфика"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="item.ContactPersonFirstName"
              class="mx-2 my-0"
              label="Имя контактного лица фабрики*"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
        </v-layout>
        <v-layout v-if="!item.AnotherLoadingPlace">
          <v-flex>
            <v-text-field
              v-model="item.ContactPersonLastName"
              class="mx-2 my-0"
              label="Фамилия контактного лица фабрики*"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="item.ContactPersonPhone"
              class="mx-2 my-0"
              label="Телефон контактного лица фабрики*"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="item.ContactPersonEmail"
              class="mx-2 my-0"
              label="E-mail контактного лица фабрики*"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="item.ContactPersonPosition"
              class="mx-2 my-0"
              label="Должность контактного лица фабрики"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-text-field
              v-model="item.LoadingPlaceTimetable"
              class="mx-2 my-0"
              label="График работы места погрузки*"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="item.LoadingPlaceContactPersonFirstName"
              class="mx-2 my-0"
              label="Имя контактного лица места погрузки*"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="item.LoadingPlaceContactPersonLastName"
              class="mx-2 my-0"
              label="Фамилия контактного лица места погрузки*"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="item.LoadingPlaceContactPersonPhone"
              class="mx-2 my-0"
              label="Телефон контактного лица места погрузки*"
              hide-details
              :rules="commonRules"
              mask="+##(###)###-##-## *#####"
            />
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-text-field
              v-model="item.LoadingPlaceContactPersonEmail"
              class="mx-2 my-0"
              label="Е-mail контактного лица места погрузки*"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="item.LoadingPlaceContactPersonPosition"
              class="mx-2 my-0"
              label="Должность контактного лица места погрузки"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="item.LoadingPlaceCountry"
              class="mx-2 my-0"
              label="Страна места погрузки*"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="item.LoadingPlaceRegion"
              class="mx-2 my-0"
              label="Регион*"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-text-field
              v-model="item.LoadingPlaceCity"
              class="mx-2 my-0"
              label="Город места погрузки*"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="item.LoadingPlaceStreetName"
              class="mx-2 my-0"
              label="Улица места погрузки*"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="item.LoadingPlaceBuildNumber"
              class="mx-2 my-0"
              label="Дом места погрузки*"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="item.LoadingPlacePostcode"
              class="mx-2 my-0"
              label="Индекс места погрузки*"
              hide-details
              :rules="commonRules"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn
          small
          color="primary"
          @click="save"
        >
          Сохранить
        </v-btn>
        <v-btn
          small
          @click="$router.go(-1)"
        >
          Отмена
        </v-btn>
        <v-spacer />
        <v-btn
          small
          color="error"
          @click="remove"
        >
          {{ "Удалить" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import * as importApi from "../../../backend/importApi.js";

export default {
  props: ["id"],
  data() {
    return {
      draft: null,
      isValid: false,
      commonRules: [v => !!v || ""],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      this.draft = await importApi.getFactoryDraft(this.id);
    },
    async save() {
      await importApi.createFactoryDraft(this.id, this.draft);
      this.showInfo("Сохранено");
      this.$router.go(-1);
    },
    async remove() {
      await importApi.deleteFactoryDraft(this.id);
      this.showInfo("Черновик удален");
      this.$router.go(-1);
    },
  },
};
</script>
